import Navbar from "@/components/Navbar";
import LegalFooter from "@/components/LegalFooter";

/** Shared layout for legal pages. Content is passed as children. */
export default function LegalPage({ title, updatedAt, children, testid }) {
  return (
    <div className="min-h-screen bg-[#080A11] text-slate-100 flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-3xl mx-auto px-6 pt-28 pb-16 w-full" data-testid={testid}>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-white">{title}</h1>
        {updatedAt && (
          <p className="text-xs text-slate-500 mt-2">Dernière mise à jour : {updatedAt}</p>
        )}
        <div className="prose prose-invert prose-slate max-w-none mt-8 text-slate-300 leading-relaxed [&_h2]:font-display [&_h2]:text-white [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-xl [&_h3]:text-white [&_h3]:font-semibold [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-base [&_ul]:list-disc [&_ul]:ml-6 [&_ul]:space-y-1 [&_p]:mb-4 [&_a]:text-violet-300 [&_a]:underline">
          {children}
        </div>
      </main>
      <LegalFooter />
    </div>
  );
}

export function ToFill({ label }) {
  return (
    <span
      data-testid="legal-tofill"
      className="inline-block px-2 py-0.5 rounded bg-amber-500/15 text-amber-300 border border-amber-500/30 text-xs font-mono"
      title="Champ à compléter par l'éditeur"
    >
      À COMPLÉTER — {label}
    </span>
  );
}
